module.exports = require('./helpers/bundle-url').getBundleURL('kQlYE') + "logo-dark.ba5147f0.svg";